import React, { useContext } from 'react';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import styles from './CollectionsList.module.pcss';

function CollectionsList(): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ rolexCollectionLinks }] = useContext(ListerContext);

  return (
    <div className={styles['collections-list']}>
      <div className={styles['collections-list__heading']}>
        <h1 className="rolex-title rolex-title--push">
          {formattedMessage({ id: 'rolex.plp.viewCollections', fallback: 'View Collections' })}
        </h1>
      </div>
      <ul>
        {rolexCollectionLinks &&
          rolexCollectionLinks.map(({ url, name }) => (
            <li className={styles['collections-list__item']} key={name}>
              <a href={url} className="rolex-text-button rolex-text-button--black-primary">
                {name}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default CollectionsList;
